import React, { createContext, useContext, useState } from 'react';

const ApiConfigContext = createContext(null);

export function ApiConfigProvider({ children }) {
  const [baseUrl, setBaseUrl] = useState(
    () => localStorage.getItem('api_base_url') || ''
  );
  const [token, setToken] = useState(
    () => localStorage.getItem('api_token') || ''
  );

  const saveConfig = (url, tok) => {
    const clean = url.replace(/\/$/, '');
    setBaseUrl(clean);
    setToken(tok);
    localStorage.setItem('api_base_url', clean);
    localStorage.setItem('api_token', tok);
  };

  return (
    <ApiConfigContext.Provider value={{ baseUrl, token, saveConfig }}>
      {children}
    </ApiConfigContext.Provider>
  );
}

export function useApiConfig() {
  return useContext(ApiConfigContext);
}
